import { Component } from '@angular/core';

@Component({
  selector: 'lh-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent {}
